import {css} from 'styled-components'
import {getCssSizeValue, getFontSize} from "@/utils/utils";
import {BREAKPOINTS} from "@/styles/themeSettings";

export default css`
    .rbc-row {
        display: flex;
        flex-direction: row;
        //background-color: red;

        &:nth-of-type(odd) {
            .rbc-event {
                background-color: var(--event-bg-1);
            }
        }
    }

    .rbc-row-segment {
        padding: 0 8px 1px 1px;

        .rbc-event-content {
            display: block;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            font-weight: ${({theme}) => theme.fontWeight.bold};
            font-size: ${getFontSize(14, BREAKPOINTS.MOBILE)};


            @media (min-width: ${({theme}) => theme.breakpoints[BREAKPOINTS.DESKTOP]}px) and (orientation: landscape) {
                font-size: ${getFontSize(14)};
            }
        }
    }

    .rbc-selected-cell {
        background-color: var(--date-selection-bg-color);
    }

    .rbc-show-more {
        display: block;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        background-color: rgba(255, 255, 255, 0.3);
        z-index: var(--event-zindex);
        font-weight: bold;
        font-size: 85%;
        height: auto;
        line-height: normal;
        color: var(--event-bg);

        &:hover,
        &:focus {
            color: var(--event-bg);
        }
    }

    .rbc-month-view {
        position: relative;
        border: 1px solid var(--calendar-border);
        border-left: none;
        display: flex;
        flex-direction: column;
        flex: 1 0 0;
        width: 100%;
        user-select: none;
        -webkit-user-select: none;

        height: 100%; // ie-fix
    }

    .rbc-month-header {
        display: flex;
        flex-direction: row;
        background-color: ${({theme}) => theme.colors.platinum};
    }

    .rbc-month-row {
        display: flex;
        position: relative;
        flex-direction: column;
        flex: 1 0 0; // postcss will remove the 0px here hence the duplication below
        overflow: hidden;
        min-height: ${getCssSizeValue(120, BREAKPOINTS.MOBILE)};

        height: 100%;

        & + .rbc-month-row {
            border-top: 1px solid var(--cell-border);
        }

        .rbc-row {
            &:not(&:first-of-type) {
                margin-bottom: ${getCssSizeValue(8)};
            }

        }

        @media (min-width: ${({theme}) => theme.breakpoints[BREAKPOINTS.DESKTOP]}px) and (orientation: landscape) {
                min-height: ${getCssSizeValue(160)};
        }
		
    }

    .rbc-date-cell {
        flex: 1 1 0;
        min-width: 0;
        //padding-right: 5px;
        text-align: right;

        &.rbc-now {
            font-weight: bold;

            .rbc-button-link {
                color: ${({theme}) => theme.colors.white};
                background-color: ${({theme}) => theme.colors.chilliRed};
            }
        }


        > a {
            &,
            &:active,
            &:visited {
                color: inherit;
                text-decoration: none;
            }
        }
    }

    .rbc-row-bg {
        overflow: hidden;
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        display: flex;
        flex-direction: row;
        flex: 1 0 0;
    }

    .rbc-day-bg {
        flex: 1 0 0;
        border-left: 1px solid var(--cell-border);
        height: 100%;

        .rbc-rtl {
            border-left-width: 0;
            border-right: 1px solid var(--cell-border);
        }
    }

    .rbc-overlay {
        position: absolute;
        z-index: calc(var(--event-zindex) + 1);
        border: 1px solid #e5e5e5;
        background-color: #fff;
        box-shadow: 0 5px 15px rgba(0, 0, 0, 0.25);
        padding: 10px;

        > * + * {
            margin-top: 1px;
        }
    }

    .rbc-overlay-header {
        border-bottom: 1px solid #e5e5e5;
        margin: -10px -10px 5px -10px;
        padding: 2px 10px;
    }

`
